import { useEffect, useRef, type EffectCallback } from 'react';

import { useSisu, type ScreenName } from '../Provider';

export default function useScreenDidMount(screen: ScreenName, effect: EffectCallback) {
	const { activeScreen } = useSisu();
	const screenDidMount = useRef(false);

	useEffect(() => {
		if (screen === activeScreen && !screenDidMount.current) {
			screenDidMount.current = true;
			return effect();
		}
		// this rule is disabled because we only want this effect to run when the screen becomes active, not on every
		// render when the dependencies change. The effect itself should be designed to only run once, similar to
		// componentDidMount.
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [screen, activeScreen]);
}
